'use strict'

class VideoSlider {
  constructor() {
  	this.video_carousel_block = null;
    this.video_carousels = null;
    this.video_elment= null;
  }

  init() {
  	this.video_carousel_block = document.querySelectorAll('.dd-video-slider');
  	if (this.video_carousel_block.length) {
  		for(i=0;i<this.video_carousel_block.length;i++) {
  			this.video_carousels = this.video_carousel_block[i].querySelectorAll('.dd-video-slider-items');	
      	if (this.video_carousels.length){
      		this.class = this.video_carousel_block[i].classList
					this.video_elment = this.class.contains('video');
        	this.initVideoSlider();
        }
  		}
  	}      
  }

  initVideoSlider() {
    const self = this;
  
  	var items_count = 1;
  	var stagePaddingTab = 100;
  	var stagePaddingDes = 230;
   
              
		self.video_carousels.forEach(function(carousel) {
			const owl = jQuery(carousel);
			const owlPrev = carousel.parentNode.querySelector('.dd-video-slider-items-nav-prev');
			const owlNext = carousel.parentNode.querySelector('.dd-video-slider-items-nav-next');
			const $dotsContainer = carousel.parentNode.querySelector('.dd-video-slider-items-nav-dots');
			owl.owlCarousel({
				nav: false,
				dots: true,
				dotsContainer: $dotsContainer,
				margin: 20,
				responsive: {
					0: {    
						items: 1,
					},
					768: {
						stagePadding: stagePaddingTab,
						loop: true,
						items: items_count,
					},
					1024: {
						stagePadding: stagePaddingDes,
						loop: true,
						items: items_count,
					},
				}
			});

			owlPrev.addEventListener('click', function(e) {
				owl.trigger('prev.owl.carousel');
			});

			owlNext.addEventListener('click', function(e) {
				owl.trigger('next.owl.carousel');
			});
		});
	}
}
